/** Endpoint paths, relative to `/api`. */
export const API_PATHS = {
    AUTH_TOKEN: '/auth/token',
    AUTH_TOKEN_REFRESH: '/auth/token/refresh',
    AUTH_LOGOUT: '/auth/logout',
    AUTH_REGISTER_REQUEST: '/auth/register/request',
    AUTH_REGISTER_COMPLETE: '/auth/register/complete',
    PASSWORD_RESET_REQUEST: '/password/reset/request',
    PASSWORD_RESET_VERIFY: '/password/reset/verify',
    PASSWORD_RESET_CHANGE: '/password/reset/change',
    REGISTER_LINK: '/register-link',
    USER_PROFILE: '/user/profile',
    USER_PROFILE_UPDATE: '/user/profile/update',
    CC_ORDER_LIST: '/cc/order-list',
    CC_ORDER_PROBLEM: '/cc/order-problem',
    DOMAIN_CONTEXT: '/domain/v1/context',
    DOMAIN_LANGUAGE: '/domain/v1/language',
    DOMAIN_TRANSLATIONS: '/domain/v1/translations',
    DOMAIN_BANNERS: '/domain/v1/banners',
    DOMAIN_STORIES: '/domain/v1/stories',
    DOMAIN_POPUPS: '/domain/v1/popups',
    DOMAIN_FEATURED_REVIEWS: '/domain/v1/reviews/featured',
    DOMAIN_OFFERS: '/domain/v1/offers',
    DOMAIN_CATALOG_SEARCH: '/domain/v1/catalog/search',
    DOMAIN_CART: '/domain/v1/cart',
    DOMAIN_CART_ITEMS: '/domain/v1/cart/items',
    DOMAIN_CART_CALCULATE: '/domain/v1/cart/calculate',
    DOMAIN_ORDERS: '/domain/v1/orders',
} as const;
